import { useCtx } from '@reatom/npm-react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { createGetContext } from './context.js';
export function useCallbackRef$(callback$) {
    const ctx = useCtx();
    return useCallbackRef(callback$(createGetContext(ctx)));
}
